import { gql } from "graphql-tag";
import { useTesQuery } from "./useTesQuery";

const GET_SHIPMENTS_QUERY = gql`
  query GetShipments($storeLocation: String!) {
    shippingses(
      filter: { takeback_id: { contains: $storeLocation } }
      pagination: { orderBy: "created_at", orderDirection: "DESC", limit: 500 }
    ) {
      items {
        updated_at
        type
        tracking_number
        takeback_id
        provider
        id
        created_at
      }
    }
  }
`;

export const useGetShipments = (storeLocation, options = {}) => {
  return useTesQuery(
    GET_SHIPMENTS_QUERY,
    { storeLocation: `${storeLocation}_` },
    {
      queryKey: ["shipments"],
      ...options,
    }
  );
};
